import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";

const keyList = {
    smsUpdate : 'setting_UPDATE',
    smsDelete : 'setting_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        settings: [],
        policy: [],

        submitSuccess: false,
        settingLoading: false,
        settingError: false,
        policyLoading: false,
        policyError: false,

        ...store
    },

    mutations : {
        ...mutations,

        SET_SETTING(state, settings) {
            state.settings = settings;
        },

        SET_POLICY(state, policy) {
            state.policy = policy;
        },

        SET_INVOLVEMENT(state, involvement) {
            state.involvement = involvement;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        },

        SETTING_LOADING (state, loading) {
            state.settingLoading = loading;
        },

        SETTING_ERROR (state, hasError) {
            state.settingError = hasError;
        },

        POLICY_LOADING (state, loading) {
            state.policyLoading = loading;
        },

        POLICY_ERROR (state, hasError) {
            state.policyError = hasError;
        }
    },

    actions: {
        async addSetting ({commit, dispatch}, payload) {
            commit('SETTING_LOADING', true);
            commit('SETTING_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_setting, payload.setting, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchSetting')
                return response

            } catch (e) {
                commit('SETTING_ERROR', true);
            } finally {
                commit('SETTING_LOADING', false);
            }
        },

        async fetchSetting ({ commit }) {
            commit('SETTING_LOADING', true);
            commit('SETTING_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.get_setting, config);
                let response = result.data.data
                commit('SET_SETTING', response);
                return result
            } catch(error) {
                commit('SETTING_ERROR', true);
            } finally {
                commit('SETTING_LOADING', false);
            }
        },

        // Policy
        async addPolicy ({commit, dispatch}, payload) {
            commit('POLICY_LOADING', true);
            commit('POLICY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.post(V1API.create_policy, payload.policy, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPolicy')
                return response

            } catch (e) {
                commit('POLICY_ERROR', true);
            } finally {
                commit('POLICY_LOADING', false);
            }
        },

        async fetchPolicy ({ commit }) {
            commit('POLICY_LOADING', true);
            commit('POLICY_ERROR', false);

            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let result = await axios.get(V1API.policy_list, config);
                let response = result.data.data
                commit('SET_POLICY', response);
                return result
            } catch(error) {
                commit('POLICY_ERROR', true);
            } finally {
                commit('POLICY_LOADING', false);
            }
        },

        async updatePolicy ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            try {
                let response = await axios.patch(V1API.update_policy + payload.id, payload.policy, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchPolicy')
                return response

            } catch (e) {
                commit('POLICY_ERROR', true);
            } finally {
                commit('POLICY_LOADING', false);
            }
        },

        async deletePolicy({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token")
                }
            };

            let response = await axios.delete(V1API.delete_policy + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchPolicy')
            return response
        }
    },

    getters: {}
}
